export default __webpack_public_path__ + "static/media/corcus.0551633d.png";